import { createSlice } from "@reduxjs/toolkit";

interface TabManagementState {
	activeSectionId: string;
	currentStep: string; // "indoor" | "outdoor"
	actualCounts: Record<string, number | null>;
}

const initialState: TabManagementState = {
	activeSectionId: "",
	currentStep: "",
	actualCounts: {},
};

const tabManagementSlice = createSlice({
	name: "tabManagement",
	initialState,
	reducers: {
		setActiveSection: (state, action) => {
			state.activeSectionId = action.payload;
		},
		setCurrentStep: (state, action) => {
			state.currentStep = action.payload;
		},
		resetTabManagement: state => {
			state.activeSectionId = "";
			state.currentStep = "";
		},
		setActualCounts: (state, action) => {
			state.actualCounts = action.payload;
		},
	},
});

export const { setActiveSection, setCurrentStep, resetTabManagement, setActualCounts } = tabManagementSlice.actions;
export default tabManagementSlice.reducer;
